import { renderDsSubPanel } from '../../../../../shared-ui/ds/subPanel.js';
import { withSettingsPresentationMode } from './settingsPresentationMode.js';

const SUB_PANEL_STATES = new Set(['Default', 'Expanded', 'Collapsed', 'Disabled']);
const SUB_PANEL_DENSITIES = new Set(['comfortable', 'compact']);

export function renderSettingsSubPanel(options = {}) {
  const normalized = withSettingsPresentationMode(options);
  const state = SUB_PANEL_STATES.has(normalized.state) ? normalized.state : 'Default';
  const density = SUB_PANEL_DENSITIES.has(normalized.density) ? normalized.density : 'compact';
  const label = normalized.label == null ? normalized.title : normalized.label;
  const className = [
    'kg-settings-compact-section',
    String(normalized.className || '').trim()
  ].filter(Boolean).join(' ');

  return renderDsSubPanel({
    ...normalized,
    label,
    state,
    density,
    className,
    footerHtml: normalized.footerHtml == null ? '' : normalized.footerHtml
  });
}
